import { Box, Button, Center, Flex, Heading, Link } from "@chakra-ui/react";
import React, { useContext } from "react";
import { AiFillStar } from "react-icons/ai";
import { GiPartyPopper } from "react-icons/gi";
import {
  FaBook,
  FaBus,
  FaCalendarAlt,
  FaHamburger,
  FaLaptop,
  FaTshirt,
} from "react-icons/fa";
import { FavouritesContext } from "../context/favourites.context";
import AppIcon from "./AppIcon";
import BottomSheetWrapper from "./BottomSheetWrapper";
import { IoIosMusicalNotes } from "react-icons/io";

const AppDrawer = () => {
  const { favourites } = useContext(FavouritesContext);

  return (
    <BottomSheetWrapper
      snapPoints={({ minHeight }) => [210, minHeight]}
      defaultSnap={150}
    >
      <Box p={5}>
        <Flex flexWrap="wrap" justify="center" alignItems="start" gap={4}>
          {/* <AppIcon
            icon={GiPartyPopper}
            to="/welcomeprogramme"
            groups={["iLancaster-staff"]}
          >
            Welcome Week
          </AppIcon> */}
          <AppIcon
            icon={FaBook}
            to="/book"
            groups={[
              "A",
              "B",
              "C",
              "D",
              "iLancaster-staff",
              "OpenILancasterProfile",
            ]}
          >
            Bookings
          </AppIcon>
          <AppIcon
            icon={FaCalendarAlt}
            to="/events"
            groups={["iLancaster-staff"]}
          >
            Events
          </AppIcon>
          <AppIcon icon={FaBus} to="/buses">
            Buses
          </AppIcon>
          {/* <AppIcon icon={FaTshirt} to="/laundry">
            Laundry
          </AppIcon> */}
          <AppIcon icon={FaHamburger} to="/outlets">
            Outlets
          </AppIcon>
          <AppIcon icon={FaLaptop} to="/pcs">
            PCs
          </AppIcon>
          {/* <AppIcon icon={IoIosMusicalNotes} to="/musicfestival">
            Music Festival
          </AppIcon> */}
          {favourites.map((favourite) => (
            <AppIcon colorScheme="yellow" icon={AiFillStar} to={favourite.url}>
              {favourite.name}
            </AppIcon>
          ))}
        </Flex>
      </Box>
      <Center mb={4}>
        <Button
          size="xs"
          as={Link}
          isExternal
          href="https://www.lancaster.ac.uk/itpi/web/services/ideasWall/topics/222"
        >
          Give Feedback
        </Button>
      </Center>
    </BottomSheetWrapper>
  );
};

export default AppDrawer;
